import {
  Injectable,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {
  Observable,
  of
} from 'rxjs';
import {
  ConsentService
} from '../services/consent.service';
import { Data2Service } from '../services/data2.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MasterGuard  {


  constructor(
    private consentService: ConsentService, 
    private router: Router,   
    private data2Service:Data2Service,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable < boolean | UrlTree > | Promise < boolean | UrlTree > | boolean | UrlTree {
    return this.canActivate(childRoute, state)
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable < boolean | UrlTree > | Promise < boolean | UrlTree > {
    //console.log("MasterGuard > canActivate >",state.url)
    if (this.isWhitelisted(state.url) || this.consentService.isFullyConsented()) {
      return of(true);
    } 
    
    //COOKIE BYPASS
    var cookie = this.getCookie("NET_TOKEN");
    if(cookie!="" && cookie!="UNKNOWN"){
      return of(true)
    }

    //RECORD OF CONSENTING ALREADY EXISTS
    if (isPlatformBrowser(this.platformId)) {
      var ls = localStorage.getItem("consents");
      if(ls!=null){
        var lsp = JSON.parse(ls)
        //console.log("lsp",lsp)
        if(lsp[0].answer =="true" && lsp[0].id=="2025-12-29-readAndUnderstoodIFAsBacktestingDisclosuresAndIndexDescriptions"){
          return of(true);
        }      
      }
    }

     //CHECK THE DATA2 API FOR WHITELISTED ARTICLE OR VIDEO
     var regexAV = "/(articles|videos)/([a-z0-9A-Z_-]+)/?"
     var matchesAV = state.url.match(regexAV);
    
     if (matchesAV != null) {
         return this.data2Service.articleVideoWhitelistCheck$(matchesAV[2]).pipe(map((wl: boolean) => {
             if (wl) {
                 return true;
             } else {
                 this.routeElsewhere2(state);
                 return false;
             }
         }));
     }

    else {
      this.routeElsewhere2(state); //Route to non whitelisted page, meaning they will likely need to consent before proceeding. Check the consent record.
      return of(false)
    }
  }

  isWhitelisted(r: string) {
    //console.log("Is the Route Whitelisted?", r, this.pagesThatDoNotContainHypotheticalBacktestedData.indexOf(r) > -1)
    //return true;
    if(r.startsWith("#id_token")){
      return true
    }
    return (this.pagesThatDoNotContainHypotheticalBacktestedData.indexOf(r) > -1);
  }
  //WHITELIST - ALL PAGES REQUIRE CONSENT EXCEPT THESE:
  //ALPHABETICALLY LISTED
  //NO PAGES BELOW SHOULD HAVE ANY HYPOTHETICAL BACKTESTED DATA / CHARTS / VIDEOS etc.
  pagesThatDoNotContainHypotheticalBacktestedData = [
   
    "/",
    "/required-consent",
    "/required-consent-stand-alone",
    "/external",
    "/about-the-paintings",
    "/app",
    "/strategy",
    "/individuals",
    "/foundations",
    "/foundations/policy",
    "/foundations/philosophy",
    "/foundations/spending",
    "/foundations/asset",
    "/foundations/alternative",
    "/foundations/process",
    "/foundations/benchmark",
    "/foundations/manager",

    "/retirement",
    //"/education",
    //"charts",
    //"portfolios",
    "/portfolios/target-date",
    "/about",
    "/about/mark",
    "/about/mary",
    "/about/elizabeth",
    "/advisors",
    "/open-account",
    "/glossary",
    "/disclosures",
    //"disclosures/history",
    "/disclosures/index-data",
    //"disclosures/charts",
    "/fees",
    "/mobile-app-privacy-policy",
    "/resources",
    //"survey",
    //"articles",
    //"videos",
    "/#id_token" 


  ];



  routeElsewhere2(state: RouterStateSnapshot) {
    //console.log("MasterGuard > routeElsewhere2 > ",state)
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem("intercepted-route", JSON.stringify({
        url: state.url,
        date: new Date()
      }));
    }
    var hasPreviousNavigation = Boolean(this.router.currentNavigation()?.previousNavigation)
    //console.log("hasPreviousNavigation",hasPreviousNavigation)
    if (!hasPreviousNavigation) {
      var matches = this.pagesThatDoNotContainHypotheticalBacktestedData.filter(x => state.url.startsWith(x));
      //console.log("matches",matches)
      if (matches != null) {
        var longest = matches.reduce(
          function (a, b) {
            return a.length > b.length ? a : b;
          }
        );
// $&("longest",longest);
        setTimeout(() => {
          this.router.navigate([longest]);
        }, 1500)
      } else {
        this.router.navigate(['/']);
      }
      setTimeout(() => {
        this.router.navigate(['/required-consent']); //just redirect to the consent page
      }, 2000)
    } else {
      this.router.navigate(['/required-consent']); //just redirect to the consent page

    }
  }

  public getCookie(name: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return '';
    }
    let ca: Array<string> = document.cookie.split(';');
    //console.log(document.cookie);
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

}